import { CalendarClockIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Avatar } from '@/components/atoms/Avatar/Avatar/Avatar';
import { EmptyValue } from '@/components/atoms/EmptyValue/EmptyValue';
import useMembers from '@/hooks/useMembers';
import type { SimulationRun } from '@/modules/simulations/types';

interface TriggeredByCellProps {
  run: SimulationRun;
}

export const TriggeredByCell = ({ run }: TriggeredByCellProps) => {
  const { t } = useTranslation();
  const { getMember } = useMembers();

  if (run.trigger_type === 'scheduled') {
    return (
      <div className="flex min-w-0 items-center gap-2 text-muted-foreground">
        <CalendarClockIcon size={16} />
        <span className="truncate">{t('simulations.scheduled')}</span>
      </div>
    );
  }

  const userId = run.triggered_by;
  if (!userId) {
    return <EmptyValue />;
  }

  const member = getMember(userId);
  const name = member?.name ?? userId;

  return (
    <div className="flex min-w-0 items-center gap-2">
      <Avatar userId={userId} size="small" hideStatus />
      <span className="truncate">{name}</span>
    </div>
  );
};
